<div class="form-section">
  <label [for]="id" [class.required-field]="required">{{ label }}</label>

  <!-- Hidden file input -->
  <input
    type="file"
    [id]="id"
    [name]="name"
    (change)="onFileSelected($event)"
    [accept]="acceptedFormats.join(',')"
    style="display: none;">

  <!-- Upload area when no avatar -->
  <div *ngIf="!avatar"
       class="avatar-upload-area"
       [class]="getDisplayModeClass()"
       [class.drag-over]="isDragOver"
       [class.uploading]="isUploading"
       (click)="triggerFileSelection()"
       (dragover)="onDragOver($event)"
       (dragleave)="onDragLeave($event)"
       (drop)="onDrop($event)">

    <!-- Upload content -->
    <div class="upload-content" *ngIf="!isUploading">
      <div class="upload-icon">
        <i class="fas fa-user-circle"></i>
      </div>
      <div class="upload-text">
        <span class="primary-text">{{ placeholder }}</span>
        <!-- <span class="secondary-text">{{ getRecommendedDimensions() }}</span>
        <span class="format-text">{{ acceptedFormats.join(', ') }}</span>
        <span class="size-text">最大 {{ maxFileSize }}MB</span> -->
      </div>
    </div>

    <!-- Upload progress -->
    <div class="upload-progress" *ngIf="isUploading">
      <div class="progress-icon">
        <i class="fas fa-spinner fa-spin"></i>
      </div>
      <div class="progress-text">
        <span>上傳中...</span>
        <div class="progress-bar">
          <div class="progress-fill" [style.width.%]="uploadProgress"></div>
        </div>
        <span class="progress-percentage">{{ uploadProgress }}%</span>
      </div>
    </div>
  </div>

  <!-- Avatar preview when uploaded -->
  <div *ngIf="avatar && !isUploading" class="avatar-preview-container">
    <div class="avatar-preview" [class]="getDisplayModeClass()">
      <!-- Loading placeholder -->
      <div *ngIf="!avatar.previewUrl" class="loading-placeholder">
        <i class="fas fa-spinner fa-spin"></i>
        <span>載入預覽中...</span>
      </div>

      <!-- Avatar image -->
      <img *ngIf="avatar.previewUrl"
           [src]="avatar.previewUrl"
           [alt]="avatar.fileName"
           class="avatar-image"
           onerror="this.src='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjYwIiBmaWxsPSIjZjVmNWY1Ii8+CjxjaXJjbGUgY3g9IjYwIiBjeT0iNDgiIHI9IjE4IiBmaWxsPSIjY2NjIi8+CjxwYXRoIGQ9Ik0yNCA5NmMwLTE5Ljg4MiAxNi4xMTgtMzYgMzYtMzZoMjRjMTkuODgyIDAgMzYgMTYuMTE4IDM2IDM2djBoLTk2djB6IiBmaWxsPSIjY2NjIi8+Cjwvc3ZnPg=='">

      <!-- Overlay for hover effects -->
      <div class="avatar-overlay">
        <div class="overlay-actions">
          <button type="button"
                  class="action-btn change-btn"
                  (click)="triggerFileSelection()"
                  title="重新上傳">
            <i class="fas fa-camera"></i>
          </button>
          <button type="button"
                  class="action-btn remove-btn"
                  (click)="removeAvatar()"
                  title="移除照片">
            <i class="fas fa-trash"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Avatar info -->
    <div class="avatar-info">
      <div class="file-name">{{ avatar.fileName }}</div>
      <div class="file-details">
        <span class="file-size">{{ formatFileSize(avatar.fileSize) }}</span>
        <span class="upload-date">{{ avatar.uploadedAt | date:'yyyy-MM-dd HH:mm' }}</span>
      </div>
    </div>
  </div>
</div>
